/*
 * @Author: wangkai 1148506760@qq.com
 * @Date: 2023-02-01 10:03:44
 * @LastEditors: wangkai 1148506760@qq.com
 * @LastEditTime: 2023-02-01 14:19:32
 * @FilePath: \hallportal-web\pc\src\util\setConfig.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export var getConfigFn = function getConfigFn(callBack) {
  // if(!window.sessionStorage.getItem('setConfig')){
  // let ajax = new XMLHttpRequest(); // 创建ajax对象
  // ajax.open("GET", process.env.BASE_URL + "serveConfig.json");
  // ajax.send();
  // ajax.onreadystatechange = function () {
  //   //  请求响应
  //   if (ajax.readyState == 4 && (ajax.status == 200 || ajax.status == 304)) {
  //     let res = JSON.parse(ajax.responseText || "{}");
  //     let use = res.use;
  //     let config = res.config;
  //     let obj = { ...config[use], currentUse: use };
  //     callBack && callBack(obj);
  //     window.sessionStorage.setItem("setConfig", JSON.stringify(obj));
  //     let faviconLink = document.querySelector("#faviconLink");
  //     if (faviconLink) {
  //       faviconLink.setAttribute("href", process.env.BASE_URL + obj.favicon);
  //     }
  //   }
  // };
  // }else{
  //     let res=JSON.parse(window.sessionStorage.getItem('setConfig'));
  //     callBack&&callBack(res);
  // }
  callBack && callBack(JSON.parse(window.sessionStorage.getItem("setConfig")));
  var faviconLink = document.querySelector("#faviconLink");

  if (faviconLink && JSON.parse(window.sessionStorage.getItem("setConfig"))) {
    faviconLink.setAttribute("href", JSON.parse(window.sessionStorage.getItem("setConfig")).favicon);
  }
};